import { MinutePageHeader } from 'components/minute/layout/MinutePageHeader';
import { MinutePageTitle } from 'components/minute/layout/MinutePageTitle';
import { ForgottenPasswordForm } from 'components/site/forms/ForgottenPasswordForm';
import CSS from 'csstype';
import { MinuteWhiteBg } from 'pages/minute/shared/MinuteWhiteBg';
import styled from 'styled-components/macro';

export interface IProps {
    style?: CSS.Properties;
    className?: string;
}

export const ForgottenPasswordPage = (): JSX.Element => {
    return (
        <S_ForgottenPasswordPage>
            <S_Center>
                <MinutePageHeader disableLogin={true} />
                <MinutePageTitle
                    title="Retrieve access"
                    subtitle="Change your password to become a true map creator"
                />
                <S_Row>
                    <S_Mid>
                        <ForgottenPasswordForm />
                    </S_Mid>
                </S_Row>
            </S_Center>
            <MinuteWhiteBg />
        </S_ForgottenPasswordPage>
    );
};

const S_ForgottenPasswordPage = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
`;

const S_Center = styled.div`
    display: flex;
    width: 1260px;
    margin: 40px 0 0 0;
    flex-direction: column;
    z-index: 1;
`;

const S_Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const S_Mid = styled.div`
    border-radius: 7px;
    background: #efefef;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    width: 400px;
    padding: 20px;
`;
